import { render } from "./ReceivedDetailReport.vue?vue&type=template&id=0d118a3d&scoped=true"
import script from "./ReceivedDetailReport.vue?vue&type=script&lang=js"
export * from "./ReceivedDetailReport.vue?vue&type=script&lang=js"

import "./ReceivedDetailReport.vue?vue&type=style&index=0&id=0d118a3d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d118a3d"]])

export default __exports__